import { connect } from 'react-redux';
import {
  resetScheduleIncrementsForm as resetScheduleIncrementsFormAction,
  updateScheduleIncrements,
} from '../Services.saga';
import {
  selectServicesIsLoading,
  selectServices,
  selectScheduleIncrements,
  selectScheduleIncrementsIsLoading,
} from '../Services.selectors';
import ScheduleIncrements from './ScheduleIncrements';

export const mapStateToProps = state => {
  return {
    isLoading: selectServicesIsLoading(state) || selectScheduleIncrementsIsLoading(state),
    services: selectServices(state),
    scheduleIncrements: selectScheduleIncrements(state),
    defaultValues: {
      serviceIds: [],
      increments: [],
    },
  };
};

const mapDispatchToProps = {
  resetScheduleIncrementsForm: resetScheduleIncrementsFormAction,
  handleSubmit: (formValues, formAsyncFns) => updateScheduleIncrements(formValues, formAsyncFns),
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleIncrements);
